// normalizeProduct — maps a Go /products row (models.Product JSON) to the engine `model` shape
// used by the cart line + itemSession. The Go JSON already matches the Android model 1:1 (incl.
// comma-joined variant fields); this just camel-cases the keys the engine reads and keeps the
// comma-joined variant strings intact (the register expands variants at add-to-cart, like Android).
//
// Bulk fields (bpId/bulkQuantity/bulkPrice/bulkIsPercentage) come from joining the Go `matches`
// bundle by product/variant id — populated only when Mix&Match (v1.1) is enabled; absent => no bulk.

const pick = (row, ...keys) => {
  for (const k of keys) if (row[k] != null) return row[k];
  return undefined;
};

export function normalizeProduct(row = {}, bulk = null) {
  const m = {
    id: row.id,
    title: row.title,
    price: row.price,
    costperItem: pick(row, "costperItem", "costperitem"),
    upc: row.upc,
    customCode: pick(row, "custom_code"),
    quantity: row.quantity,
    purchaseQty: pick(row, "purchase_qty"),
    isvarient: row.isvarient,
    trackqnty: row.trackqnty,
    isstockcontinue: row.isstockcontinue,
    cotegory: row.cotegory,
    categoryName: pick(row, "category_name"),
    otherTaxes: pick(row, "other_taxes"),
    foodStampable: pick(row, "food_stampable"),
    isTobacco: pick(row, "is_tobacco"),
    isLottery: pick(row, "is_lottery"),
    bogoId: pick(row, "bogo_id"),
    brand: row.brand,
    brandId: pick(row, "brand_id"),
    media: row.media,
    showType: pick(row, "show_type"),
    disable: row.disable,
    uom: row.uom,
    manufacturer: row.manufacturer,
    consumerUnit: pick(row, "consumer_unit"),
    options1: row.options1,
    options2: row.options2,
    options3: row.options3,
    // variant fields (comma-joined strings, kept as-is)
    vVariantId: pick(row, "vvariant_id"),
    vupc: row.vupc,
    vCustomCode: pick(row, "vcustom_code"),
    vVariant: pick(row, "vvariant"),
    vPrice: pick(row, "vprice"),
    vCostPrice: pick(row, "vcost_price"),
    vQuantity: pick(row, "vquantity"),
    vTrackQnty: pick(row, "vtrackqnty"),
    vIsStockContinue: pick(row, "visstockcontinue"),
    vFoodStampable: pick(row, "vfood_stampable"),
    vIsTobacco: pick(row, "vis_tobacco"),
    vDisable: pick(row, "vdisable"),
    // bulk / mix&match (v1.1)
    bpId: bulk ? bulk.id : undefined,
    bulkQuantity: bulk ? bulk.min_qty : undefined,
    // max_qty — how many UNITS of the group may be bulk-priced. Blank/0 = unlimited. Android reads it
    // off the deal rather than the product because its local product table has no such column; the web
    // joins the whole deal row here, so it rides along with min_qty/discount.
    bulkMaxQty: bulk ? bulk.max_qty : undefined,
    bulkPrice: bulk ? bulk.discount : undefined,
    bulkIsPercentage: bulk ? bulk.is_percent : undefined,
    bulkDealName: bulk ? bulk.deal_name : undefined, // for altria_discount_desc
    bulkAltriaFundedDiscount: bulk ? bulk.altria_funded_discount : undefined,
    bulkPromotionCode: bulk ? bulk.promotion_code : undefined, // Altria LFP code, AGDC field 29
  };
  return m;
}
